import { LoginCallback, SecureRoute } from '@okta/okta-react';
import { Route, Redirect } from 'react-router-dom';
import LandingPage from './components/LandingPage/LandingPage';
import { URL_ROUTES } from './adapters/constants';
import StyledAuthWrapper from './styled';
import NewOrderTransmissionWrapper from './components/NewOrderTransmission/NewOrderTransmissionWrapper';
import PartOrderDetails from './components/OrderHistoryDashboard/PartOrderDetails';

const AuthWrapper = (): JSX.Element => (
  <>
    <StyledAuthWrapper id="App" data-testid="wrapped-component">
      <SecureRoute
        exact
        path="/"
        render={() => <Redirect to={URL_ROUTES.landingPage} />}
      />
      <SecureRoute
        exact
        path={URL_ROUTES.landingPage}
        render={() => <LandingPage />}
      />
      <SecureRoute exact path={URL_ROUTES.newOrderTransmissionPage}
        render={() => <NewOrderTransmissionWrapper />} />

      <SecureRoute exact path={URL_ROUTES.partOrderDetailPage}
        render={() => <PartOrderDetails />} />
      <Route path="/" component={LoginCallback} />
    </StyledAuthWrapper>
  </>
);

export default AuthWrapper;
